import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputField from "./InputField";
import Modal from "react-bootstrap/Modal";
import { useFlash } from "../../contexts/FlashProvider";
import { useUser } from "../../contexts/UserProvider";
import FlashMessage from "../Navigation/FlashMessage"; 
import './loginpage.css'; // Importing the CSS file for custom styles

export default function LoginPage() {
  const [formErrors, setFormErrors] = useState({});
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const usernameField = useRef();
  const passwordField = useRef();
  const { login } = useUser();
  const { flash, hideFlash } = useFlash();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("timedout")) {
      flash("Your session timed out. Please log in again.", "danger");
      
      // Remove the timedout query parameter from the URL
      searchParams.delete("timedout");
      navigate({ search: searchParams.toString() }); // Update the URL without reloading the page
    }
  }, [flash, location.search, navigate]);

  const onForgotPassword = () => {
    setShowForgotPassword(true);
  };

  const onSubmit = async (ev) => {
    ev.preventDefault();
    const username = usernameField.current.value;
    const password = passwordField.current.value;

    const errors = {};
    if (!username) {
      errors.username = "Username must not be empty.";
    }
    if (!password) {
      errors.password = "Password must not be empty.";
    }
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }

    const result = await login(username, password);
    if (result === "fail") {
      console.log('Login failed');
      flash("Invalid username or password", "danger");
    } else if (result === "ok") {
      flash(null, null); // clear flash if any
      hideFlash();
      navigate("/"); // to explore page
    }
  };

  return (
    <div className="login-container">
      <FlashMessage />
      <h1 className="welcome-message">Welcome to the IPC Dashboard!</h1>
      <h2>Please log in to continue.</h2>
      <Form onSubmit={onSubmit} className="login-form">
        <InputField
          name="username"
          label="Username or email address"
          error={formErrors.username}
          fieldRef={usernameField}
        />
        <InputField
          name="password"
          label="Password"
          type="password"
          error={formErrors.password}
          fieldRef={passwordField}
        />
        <Button variant="primary" type="submit" className="login-button" style={{ marginTop: "2rem" }}>
          Login
        </Button>
        <div className="login-links">
          <Link to="/register">Register as a new user</Link>
          <button
            type="button"
            className="link-button"
            onClick={onForgotPassword}
          >
            Forgot password or invite code?
          </button>
        </div>
      </Form>
      <Modal
        show={showForgotPassword}
        onHide={() => setShowForgotPassword(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Forgot password?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Please email{" "}
          <a href="mailto:augustine.luk@ndm.ox.ac.uk">
            augustine.luk@ndm.ox.ac.uk
          </a>{" "}
          for next steps.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setShowForgotPassword(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
